/* oxlint-disable no-inner-declarations */
import { ok } from '@oazapfts/runtime';
import * as rq from '@tanstack/react-query';

import { useMe } from '@/hooks/use-me';

import { documentationV1QuickstartGuideRetrieve } from '../fetch-client';
import { useFetchOpts } from '../use-fetch-opts';

export namespace DownloadQuickstartGuide {
  export type Output = { file: File };

  function outputFromResult(result: Blob): Output {
    return { file: new File([result], 'quickstart-guide.pdf') };
  }

  export function useMutation() {
    const getOpts = useFetchOpts();
    const me = useMe();

    return rq.useMutation<Output, unknown>({
      async mutationFn() {
        const opts = await getOpts();
        const result = await ok(
          documentationV1QuickstartGuideRetrieve(
            { customerType: me.config.type },
            opts,
          ),
        );
        const output = outputFromResult(result);
        return output;
      },
    });
  }
}
